import {bindActionCreators} from 'redux'
import {BaseAction} from '../../common/BaseAction'
import {PushActionsTypes} from './types'
import {PushClientDTO} from 'grilnica-store-share'

export const Actions = {
  setPushMessages: (pushMessages: PushClientDTO[]): BaseAction => ({
    type: PushActionsTypes.SET_PUSH_MESSAGES,
    payload: pushMessages,
  }),

  readPushMessageRequest: (pushQueueId: string): BaseAction => ({
    type: PushActionsTypes.READ_PUSH_MESSAGE_REQUEST,
    payload: {pushQueueId},
  }),
  readMessageSuccess: (pushQueueId: string): BaseAction => ({
    type: PushActionsTypes.READ_PUSH_MESSAGE_SUCCESS,
    payload: {pushQueueId},
  }),

  hidePushMessageRequest: (pushQueueId: string): BaseAction => ({
    type: PushActionsTypes.HIDE_PUSH_MESSAGE_REQUEST,
    payload: {pushQueueId},
  }),
  hidePushMessageSuccess: (pushQueueId: string): BaseAction => ({
    type: PushActionsTypes.HIDE_PUSH_MESSAGE_SUCCESS,
    payload: {pushQueueId},
  }),
}

export type PushActionsType = typeof Actions

export function bindPushActions(dispatch: any) {
  return bindActionCreators(Actions, dispatch)
}
